export default __webpack_public_path__ + "images/2beff2a6-check.svg";